export default "__VITE_ASSET__CJwMDO0s__"